import React from 'react';

const R = ({ width, color }) => (
  <svg viewBox="0 0 73.99 87.34" width={width} >
    <g stoke={color} fill={color}>
      <path d="M53.47,87.34,33,53.86H21.46v5.86L5.65,46.91,21.46,34.1V40H34.68q7.95,0,11.72-3.11t3.77-9.59q0-6.48-3.77-9.59T34.68,14.56H0V0H37.07Q52,0,60.42,7.08T68.83,27q0,9.39-4.64,15.74A25.46,25.46,0,0,1,51,51.87L74,87.34Z" />
    </g>
  </svg>
);

export default R;
